import { render } from "./ClientServiceTxlStationTotal.vue?vue&type=template&id=62a6dfa4&scoped=true&ts=true"
import script from "./clientServiceStationTxlHelper.ts?vue&type=script&lang=ts"
export * from "./clientServiceStationTxlHelper.ts?vue&type=script&lang=ts"

import "./ClientServiceTxlStationTotal.vue?vue&type=style&index=0&id=62a6dfa4&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a6dfa4"]])

export default __exports__